const RECEIVE_ADPORTFOLIOS = 'src/adEntities/RECEIVE_ADPORTFOLIOS';
const CLEAR_ADPORTFOLIOS = 'src/adEntities/CLEAR_ADPORTFOLIOS';
const RECEIVE_ADPORTFOLIOS_DATA = 'src/adEntities/RECEIVE_ADPORTFOLIOS_DATA';
const CLEAR_ADPORTFOLIOS_DATA = 'src/adEntities/CLEAR_ADPORTFOLIOS_DATA';

export default {
  CLEAR_ADPORTFOLIOS,
  RECEIVE_ADPORTFOLIOS,
  CLEAR_ADPORTFOLIOS_DATA,
  RECEIVE_ADPORTFOLIOS_DATA
};
